<template>
  <div id="vueArchive">
    <div class="category-wrapper">
      <h1 class="category-title" v-if="year">{{ tagName }} {{ year }}年{{ month }}月一覧</h1>
      <h1 class="category-title" v-else>{{ tagName }} 一覧</h1>
      <pagenation :count="count" :per-page="30"></pagenation>
      <transition-group name="fade" tag="ul" class="category-entry-list">
        <entry v-for="(entry, index) in entryList" :key="index" :entry="entry"></entry>
      </transition-group>
      <pagenation :count="count" :per-page="30"></pagenation>
      <archive-calendar :categoryArray="categoryArray"></archive-calendar>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import entry from './entryItem'
import pagenation from './pagenation'
export default {
  components: {
    entry,
    pagenation
  },
  data() {
    return {
      tagName: '',
      entryList: [],
      count: 0,
      year: undefined,
      month: undefined
    }
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData() {
      const name = this.$route.params.name
      this.tagName = name
      const year = this.$route.params.year
      const month = this.$route.params.month
      const pubmonth = `${year}${month}`
      const channel = this.$route.params.channel
      let url
      if (channel) {
        url = `https://d23x6lpzsdpoqh.cloudfront.net/search/${channel}/tag/${name}`
      } else {
        url = `https://d23x6lpzsdpoqh.cloudfront.net/search/tag/${name}`
      }
      if (year) {
        const params = {
          m: pubmonth
        }
        if(this.$route.query.page){
          params.page = this.$route.query.page
        }
        axios
          .get(url, {
            params: params
          })
          .then(response => {
            this.year = year
            this.month = month
            const data = response.data
            this.count = data.count
            this.$set(this, 'entryList', data.articles)
            document.body.scrollTop = 0
          })
      } else {
        const params = {}
        if(this.$route.query.page){
          params.page = this.$route.query.page
        }
        axios.get(url, {params: params}).then(response => {
          const data = response.data
          this.count = data.count
          this.year = ''
          this.month = ''
          this.$set(this, 'entryList', data.articles)
          document.body.scrollTop = 0
        })
      }
    }
  }
}
</script>

psgi